module.exports = __webpack_public_path__ + "media/static/icons/icon-break-37b91d6d359180c6e6b469d36d80b773.svg";